var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-content-toolbar',{attrs:{"projectName":"404 NOT FOUND"}}),_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('global.404NotFound'))+" :'(")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }